<template>
  <div class="app_container">
    <!--操作栏-->
    <div class="filter_container">
      <div class="handler">
        <el-tabs
          class="tab"
          v-model="questionType"
          size="small"
          type="card"
          @tab-click="handleClick"
        >
          <el-tab-pane label="单选题" name="0"></el-tab-pane>
          <el-tab-pane label="多选题" name="1"></el-tab-pane>
          <el-tab-pane label="判断题" name="2"></el-tab-pane>
          <el-tab-pane label="填空题" name="3"></el-tab-pane>
          <el-tab-pane label="问答题" name="4"></el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!--表格内容栏-->
    <Tables @selection-change="selectionChange" :data="resultPage" />
    <!--分页栏-->
    <div class="RCPagination">
      <butn
        style="float: left;"
        btntype="primary"
        iconName="el-icon-arrow-left"
        title="返回"
        @click="$router.back()"
      ></butn>
      <RCPagination
        ref="pagination"
        v-model="resultPage"
        :api="api"
        :startRequest="false"
      />
    </div>
    <statistics />
  </div>
</template>
<script>
import RCPagination from "@/components/pagination/paginationManage";
import Tables from "./table.js";
import butn from "@/components/button/index";
import { getResultPage } from "@/api/investigation";
import Statistics from "./statistics";
export default {
  components: {
    Tables,
    butn,
    RCPagination,
    Statistics
  },
  data() {
    return {
      size: "small",
      questionType: 0,
      resultPage: [],
      api: getResultPage
    };
  },
  methods: {
    selectionChange: function(selections) {
      this.selections = selections;
    },
    handleClick(tab) {
      this.questionType = tab.name;
      this.$refs["pagination"].search({
        questionType: this.questionType,
        uuid: this.$route.query.id
      });
    }
  },
  created() {
    this.$nextTick(() => {
      this.$refs["pagination"].search({
        questionType: this.questionType,
        uuid: this.$route.query.id
      });
    });
  }
};
</script>
<style lang="scss" scoped>
.handler {
  margin-bottom: 10px;
  position: relative;
  .tab {
    width: 100%;
  }
}
</style>
